export abstract class StringFormat {
    /**
     * Cleans a string by normalizing and removing diacritical marks
     *
     * @param value
     * @returns
     */
    private static cleanString(value: string): string {
      return value
        .toLowerCase()
        .trim()
        .normalize("NFD")
        .replace(/\u0300-\u036f/g, "");
    }
  
    /**
     * Formats a string to its slug value
     *
     * @param value
     * @returns
     */
    static formatSlug(value: string): string {
      if (!value || typeof value !== "string") {
        return "";
      }
  
      return StringFormat.cleanString(value)
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    }
  
    /**
     * Compacts a string by removing spaces and invalid characters
     *
     * @param value
     * @returns
     */
    static compactString(value = "", options?: { lowerCase?: boolean }): string {
      if (!value || typeof value !== "string") {
        return "";
      }
    
      const cleanedValue = value.trim().normalize("NFD").replace(/\p{Diacritic}/gu, "");
      const compactedString = cleanedValue.replace(/[^a-zA-Z0-9]/g, "");
    
      return options?.lowerCase ? compactedString.toLowerCase() : compactedString;
    }
  
    /**
     * Capitalize words in a string
     *
     * @param value
     * @returns
     */
    static capitalizeWords(
      value: string,
      options?: { onlyFirstWord?: boolean }
    ): string {
      if (!value || typeof value !== "string") return "";
      return value
        .toLocaleLowerCase()
        .split(" ")
        .map((word, index) =>
          options?.onlyFirstWord && index > 0
            ? word
            : word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(" ");
    }
  
    /**
     * Truncate a string
     *
     * @param text
     * @param maxLength
     * @returns
     */
    static truncateString(text: string, maxLength: number): string {
      return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    }
  
    static toKebabCase(text: string): string {
      return text.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    }
  }
  